export * from './resource-capacity.interface';
